import { Injectable, Type } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { BehaviorSubject, Subject } from 'rxjs';
import { DialogReturnType } from './dialog-return-type.enum';
import { DialogReturn } from './dialog-return.model';

export interface OpenDialogOptions<T = any> {
    args?: T;
    submitButtonText?: string | null;
    secondaryButtonText?: string | null;
    maxWidth?: string;
    height?: string;
    draggable?: boolean;
    panelClass?: string;
}


@Injectable({ providedIn: 'root' })
export class DialogService<T> {

    public component!: Type<any>;
    public dialogTitle = "";
    public show: boolean = false;
    public displayed$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public submitButtonEnabled$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public secondaryButtonEnabled$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
    public closeButtonEnabled$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
    public submit$: Subject<DialogReturn<T>> = new Subject();
    public args: any;
    public submitButtonText: string | null = 'save';
    public secondaryButtonText: string | null = null;
    public message$: BehaviorSubject<SafeHtml> = new BehaviorSubject<SafeHtml>("");
    public topRightCornerHTML$: BehaviorSubject<SafeHtml> = new BehaviorSubject<SafeHtml>("");
    public maxWidth: string = "800px";
    public height: string = "80%";
    public draggable: boolean = false;
    public panelClass: string = '';
    public opened$: BehaviorSubject<string> = new BehaviorSubject<string>('')

    constructor() {
    }

    public openDialog<TComponent, TArgs>(
        component: Type<TComponent>,
        title: string,
        options: OpenDialogOptions<TArgs> = {},
    ) {
        if (this.displayed$.value) return;

        const defaults: Required<OpenDialogOptions<TArgs>> = {
            args: {} as TArgs,
            submitButtonText: 'save',
            secondaryButtonText: null,
            maxWidth: '800px',
            height: '80%',
            draggable: true,
            panelClass: '',
        };

        const merged = { ...defaults, ...options };

        this.submitButtonText = merged.submitButtonText;
        this.secondaryButtonText = merged.secondaryButtonText;
        this.dialogTitle = title;
        this.args = merged.args;
        this.maxWidth = merged.maxWidth;
        this.height = merged.height;
        this.draggable = merged.draggable;
        this.panelClass = merged.panelClass;
        this.component = component;

        this.opened$.next(title);
        this.displayed$.next(true);

        setTimeout(() => (this.show = true), 150);
    }

    public closeDialog() {

        this.submit$.next({ value: null, type: DialogReturnType.CANCEL })
        this.submit$.complete()
        this.submit$ = new Subject()
        this.closeButtonEnabled$.next(true);
        this.secondaryButtonEnabled$.next(true);
        this.message$.next('')
        this.submitButtonEnabled$.next(false);
        this.panelClass = '';

        this.show = false
        setTimeout(() => {
            this.displayed$.next(false);
        }, 150)
    }

}
